<template>
  <div>
    <div class="wrapper" :class="{ 'vega-sidebar--collapsed': isDesktop && sidebarCollapsed, 'vega-sidebar--drawer-open': drawerOpen }">
      <!-- Sidebar  -->
      <SideBarStyle :logo-full="logoFull" :logo-icon="logoIcon" :rail="isDesktop && sidebarCollapsed"
                    :drawer-open="drawerOpen" @toggle-rail="toggleSidebarCollapsed" @close="drawerOpen = false" />
      <transition name="vega-backdrop">
        <div v-if="drawerOpen" class="vega-sidebar-backdrop" @click="drawerOpen = false"></div>
      </transition>
      <div id="content-page" class="content-page overflow-auto">
        <!-- TOP Nav Bar -->
        <NavBarStyle @toggle="drawerOpen = !drawerOpen">
          <template v-slot:responsiveRight>
            <ul class="navbar-nav ms-auto navbar-list">
              <li class="nav-item iq-full-screen">
                <button type="button" class="vega-hbtn" id="btnFullscreen"
                        :aria-label="isFullscreen ? $t('ExitFullScreen') : $t('FullScreen')"
                        :title="isFullscreen ? $t('ExitFullScreen') : $t('FullScreen')"
                        @click="fullscreen"><i :class="$faIcon(fullscreenIcon)" aria-hidden="true"></i></button>
              </li>
             <currency-rates></currency-rates>
             <notifications></notifications>
            </ul>
          </template>
          <template v-slot:right>
            <UserBar />
          </template>
        </NavBarStyle>
        <!-- TOP Nav Bar END -->
        <modal v-if="$router.currentRoute.meta.isModal == true" :key="$router.currentRoute.name"></modal>
        <!-- Eski ekran anında gider, yeni ekran kısa bir belirmeyle gelir (light/style.scss `.vega-page-*`). -->
        <router-view v-slot="{ Component }">
          <transition name="vega-page" mode="out-in" @after-enter="observeLayout">
            <component :is="Component" :key="routerViewKey" />
          </transition>
        </router-view>
        <FooterStyle>
          <template v-slot:left>
            <span>© {{ currentYear }} Softage Yazılım A.Ş.</span>
          </template>
        </FooterStyle>
      </div>
    </div>
    <AiAssistantFab />
  </div>
</template>
<script>
  import SideBarStyle from '../components/xray/sidebars/SideBarStyle'
  import NavBarStyle from '../components/xray/navbars/NavBarStyle'
  import FooterStyle from '../components/xray/footer/FooterStyle'
  import UserBar from '../components/xray/navbars/UserBar'
  import Modal from '../views/Pages/Shared/Modal'
  import profile from '../assets/images/user/1.jpg'
  import logoFull from '../assets/images/logo-wordmark.png'
  import logoIcon from '../assets/images/logo-icon.png'
  import authService from '../services/auth'
  import Notifications from '../components/xray/Notifications'
  import CurrencyRates from '../components/xray/CurrencyRates'
  import AiAssistantFab from '../components/assistant/AiAssistantFab.vue'
  import { appRouteViewKey } from '../services/settingsNavigation'
  import { fillLayoutHeight } from '../utils/fillLayoutHeight'

  // assets/css/sidebar.css: ≥1200px sabit menü (daraltılabilir), altında çekmece.
  const desktopQuery = typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 1200px)') : null
  const SIDEBAR_COLLAPSED_KEY = 'vega.sidebarCollapsed'

  // Kişisel görünüm tercihi; depolama kapalıysa menü açık başlar.
  function readSidebarCollapsed() {
    try {
      return window.localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1'
    } catch (e) {
      return false
    }
  }

  function writeSidebarCollapsed(value) {
    try {
      window.localStorage.setItem(SIDEBAR_COLLAPSED_KEY, value ? '1' : '0')
    } catch (e) {
      // Depolama kapalı: tercih yalnız bu oturumda kalır.
    }
  }

  export default {
    name: 'Layout',
    components: {
      SideBarStyle,
      NavBarStyle,
      FooterStyle,
      UserBar,
      Modal,
      Notifications,
      CurrencyRates,
      AiAssistantFab
    },
    data() {
      return {
        sidebarCollapsed: readSidebarCollapsed(),
        currentYear: new Date().getFullYear(),
        drawerOpen: false,
        isDesktop: desktopQuery ? desktopQuery.matches : true,
        darkMode: false,
        fullscreenIcon: 'fa-regular fa-expand',
        userProfile: profile,
        logoFull: logoFull,
        logoIcon: logoIcon,
        notification: [
          { image: require('../assets/images/user/01.jpg'), name: 'Nik Emma Watson', date: '23 hour ago', description: 'Enjoy smart access to videos, games' },
          { image: require('../assets/images/user/02.jpg'), name: 'Greta Life', date: '14 hour ago', description: 'Google Chromecast: Enjoy a world of entertainment' },
          { image: require('../assets/images/user/03.jpg'), name: 'Barb Ackue', date: '16 hour ago', description: 'Dell Inspiron Laptop: Get speed and performance from' },
          { image: require('../assets/images/user/04.jpg'), name: 'Anna Sthesia', date: '21 hour ago', description: 'Deliver your favorite playlist anywhere in your home ' },
          { image: require('../assets/images/user/05.jpg'), name: 'Bob Frapples', date: '11 hour ago', description: 'MacBook Air features up to 8GB of memory, a fifth-generation' }
        ]
      }
    },
    computed: {
      isFullscreen() {
        return this.fullscreenIcon === 'fa-regular fa-compress'
      },
      // Ayarlar ve Tanımlamalar tek kabuk örneğini paylaşır; sekme değişince kabuk yeniden
      // kurulmaz. Danışan özeti danışan başına, diğer sayfalar ekran adına göre anahtarlanır.
      // Anahtar değişince (ya da aynı anahtarda bileşen değişince) geçiş animasyonu oynar.
      routerViewKey() {
        if (this.$router.currentRoute.meta.name == 'CustomerSummary')
          return this.$router.currentRoute.meta.name + '|' + this.$router.currentRoute.params.customerId;
        return appRouteViewKey(this.$route, this.$route.meta.name);
      }
    },
    watch: {
      // Yeni ekran baştan açılır; kabuk içi sekme geçişi (aynı anahtar) kaydırma konumunu korur.
      routerViewKey() {
        window.scrollTo(0, 0)
      },
      '$route.fullPath'() {
        this.drawerOpen = false
        this.$nextTick(this.observeLayout)
      }
    },
    methods: {
      toggleSidebarCollapsed() {
        this.sidebarCollapsed = !this.sidebarCollapsed
        writeSidebarCollapsed(this.sidebarCollapsed)
        // Grafikler ve takvim genişliği pencere boyutundan ölçer.
        this.$nextTick(() => window.dispatchEvent(new Event('resize')))
      },
      onDesktopChange(event) {
        this.isDesktop = event.matches
        if (event.matches) this.drawerOpen = false
      },
      // Esc ya da tarayıcı menüsüyle çıkılınca da simge ve etiket doğru kalır.
      onFullscreenChange() {
        this.fullscreenIcon = document.fullscreenElement ? 'fa-regular fa-compress' : 'fa-regular fa-expand'
      },
      // Kısa içerikte sütunların son kartı alt şeride kadar uzar (utils/fillLayoutHeight.js). Sayfa kökü ve
      // route modalı izlenir: veri yüklenince, akordeon açılınca ya da pencere boyu değişince yeniden ölçülür.
      observeLayout() {
        const contentPage = this.$el.querySelector && this.$el.querySelector('#content-page')
        if (!contentPage || !this.layoutObserver) return
        this.layoutObserver.disconnect()
        Array.from(contentPage.children).forEach((child) => {
          if (!child.matches('.iq-top-navbar, .iq-footer')) this.layoutObserver.observe(child)
        })
        this.scheduleFillLayout()
      },
      scheduleFillLayout() {
        if (this.fillFrame) return
        this.fillFrame = window.requestAnimationFrame(() => {
          this.fillFrame = null
          fillLayoutHeight(this.$el.querySelector('#content-page'))
        })
      },
      onKeyDown(event) {
        if (event.key === 'Escape' && this.drawerOpen) this.drawerOpen = false
      },
      logout() {
        authService.logout()
      },
      fullscreen() {
        if (!document.fullscreenElement &&
          !document.mozFullScreenElement &&
          !document.webkitFullscreenElement &&
          !document.msFullscreenElement) {
          if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
          } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          }
          this.fullscreenIcon = 'fa-regular fa-compress';
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
          this.fullscreenIcon = 'fa-regular fa-expand';
        }
      }
    },
    mounted() {
      if (desktopQuery) desktopQuery.addEventListener('change', this.onDesktopChange)
      document.addEventListener('keydown', this.onKeyDown)
      document.addEventListener('fullscreenchange', this.onFullscreenChange)
      if (typeof ResizeObserver !== 'undefined') this.layoutObserver = new ResizeObserver(this.scheduleFillLayout)
      // İlk açılışta sayfa bileşeni (lazy chunk) Layout'tan sonra gelir ve geçiş animasyonu oynamaz; içerik de sonradan
      // değişebilir (yükleniyor kutusu → asıl kart) ama uzatılmış bir sütun sayfa kökünün boyunu sabit tutar. Eklenen/
      // çıkan her düğümde yeniden ölçülür; yazılan min-height öznitelik değişikliğidir, bunu tetiklemez.
      const contentPage = this.$el.querySelector('#content-page')
      if (contentPage && typeof MutationObserver !== 'undefined') {
        this.pageRootObserver = new MutationObserver(this.observeLayout)
        this.pageRootObserver.observe(contentPage, { childList: true, subtree: true })
      }
      window.addEventListener('resize', this.scheduleFillLayout)
      this.$nextTick(this.observeLayout)
    },
    beforeUnmount() {
      if (desktopQuery) desktopQuery.removeEventListener('change', this.onDesktopChange)
      document.removeEventListener('keydown', this.onKeyDown)
      document.removeEventListener('fullscreenchange', this.onFullscreenChange)
      window.removeEventListener('resize', this.scheduleFillLayout)
      if (this.layoutObserver) this.layoutObserver.disconnect()
      if (this.pageRootObserver) this.pageRootObserver.disconnect()
      if (this.fillFrame) window.cancelAnimationFrame(this.fillFrame)
    }
  }
</script>
<style>
  @import url("../assets/css/custom.css");
</style>
